import { memo, useMemo, useCallback, useEffect, useState, createRef } from 'react';
import { View, StyleSheet, Text } from 'react-native';
import { I18n, Utils, Container, TextInputPlain, FormFooter, Navigation } from '../../components';
import { THEME, __WEB__, COLOR, FONT } from '../../../constants/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../../actions/statusTypes';
import { resetStatus } from '../../employer/actions';

export default memo(
  connect(
    function (state, ownProps) {
      return {
        saveSetupDataStatus: state.screens.employer.saveSetupDataStatus,
        errorMessage: state.screens.employer.errorMessage,
      };
    },
    function (dispatch) {
      return {
        actions: bindActionCreators({ resetStatus }, dispatch),
      };
    }
  )(function (props) {
    useEffect(
      function () {
        if (props.saveSetupDataStatus === SUCCESS) Navigation.dismissAllModals();
      },
      [props.saveSetupDataStatus]
    );
    useEffect(function () {
      return function () {
        props.actions.resetStatus();
      };
    }, []);
    const [text, setText] = useState('');

    function handleChangeText(text) {
      setText(text);
    }

    function handleCancel() {
      Navigation.dismissAllModals();
    }

    function handleSave() {
      props.onSave(text);
    }

    const footer = (
      <FormFooter
        onCancel={handleCancel}
        onSave={handleSave}
        saveDisabled={!text?.trim()}
        cancelLabel="Cancel"
        saveLabel="Add"
      />
    );

    return (
      <Container
        scrollView={false}
        style={THEME.container}
        stickyFooter={footer}
        renderActivityOverlay={props.saveSetupDataStatus === REQUESTING}
        errorMessage={props.errorMessage?.message}
      >
        <View style={styles.container}>
          <View style={{ maxWidth: 400, paddingTop: 35, paddingBottom: 25 }}>
            <Text style={THEME.textRegular}>
              {`Please type or copy/paste a list of all ${props.title}s at your base. Make sure there is a comma (,) separating each ${props.title} you enter.`}
            </Text>
          </View>

          <View style={styles.inputContainer}>
            <TextInputPlain
              multiline={true}
              style={styles.input}
              placeholder={props.placeholderText}
              placeholderTextColor={'rgb(174,174,174)'}
              onChangeText={handleChangeText}
            />
          </View>
        </View>
      </Container>
    );
  })
);

const styles = StyleSheet.create({
  container: {
    ...THEME.container,
    alignItems: 'center',
    paddingBottom: 40,
  },
  inputContainer: {
    width: '100%',
    maxWidth: 400,
    flex: 1,
    borderWidth: 1.5,
    borderRadius: 10,
    borderColor: 'rgb(170,170,170)',
    backgroundColor: COLOR.contrast,
    padding: 10,
    paddingHorizontal: 15,
  },
  input: {
    ...THEME.input,
    ...FONT.regular,
    fontSize: __WEB__ ? 12 : 12,
  },
});
